import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'
import Home from './views/Home.vue'

Vue.use(Router)
Vue.use(Meta)

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/policies',
            name: 'policies',
            component: () => import('./views/Policies.vue')
        },
        {
            path: '/download',
            name: 'download',
            beforeEnter: () => {
                window.location = 'https://play.google.com/store/apps/details?id=net.xupisco.prayforme'
            }
            //component: () =>  import('./views/Download.vue')
        },
        {
            path: '/pedido/:pray_id',
            name: 'pray_detail',
            component: () => import('./views/PrayDetail.vue'),
            props: true
        }
    ]
})
